// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import goodsReceipt from "./locales/en/goodsReceipt.json";
import ArgoodsReceipt from "./locales/ar-AE/ArgoodsReceipt.json";



import salesOrderEn from "./locales/en/salesOrder.json";
import salesOrderAr from "./locales/ar-AE/salesOrder.json";


// ⭐ NEW: Common Table Translation Imports
import commonTableEn from "./locales/en/commonTable.json";
import commonTableAr from "./locales/ar-AE/commonTable.json";

const resources = {
    en: {
        translation: {
            goodsReceipt: goodsReceipt,
            salesOrder: salesOrderEn,
            commonTable: commonTableEn,

            common: {
                language: {
                    english: "English",
                    arabic: "Arabic (UAE)"
                }
            }
        }
    },

    "ar-AE": {
        translation: {
            goodsReceipt: ArgoodsReceipt,
            salesOrder: salesOrderAr,
            commonTable: commonTableAr,
            common: {
                language: {
                    english: "الإنجليزية",
                    arabic: "العربية (الإمارات)"
                }
            }
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        supportedLngs: ["en", "ar-AE"],
        detection: {
            order: ["localStorage", "querystring", "cookie", "navigator", "htmlTag"],
            caches: ["localStorage"]
        },
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false // taaki Suspense wrap na karna pade
        }
    });

// RTL / LTR switch
i18n.on("languageChanged", (lng) => {
    if (typeof document !== "undefined") {
        document.documentElement.dir = lng.startsWith("ar") ? "rtl" : "ltr";
        document.documentElement.lang = lng;
    }
});

export default i18n;
